<template>
    <div class="home-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li><span>{{$t('LifeCulture')}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/life-bg.jpg) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp fw7">せいかつとぶんか</div>
                  <div class="jp">{{$t('LifeCulture')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
		<div class="">
      <div class="content crfff por">
        <div class="kanji-content mt30">
          <div class="life-wrap" style="margin: 0 20px;">
            <div class="" :id="'Topic'+(index+1)" v-for="(item,index) in list">
              <div class="step1 bd disflex" style="padding-bottom: 30px;">
                <div class="step1-num" >{{item.topic}}</div>
                <div class="step1-content">
                  <strong>{{item.topic_name_jp}}</strong>
                  <div><em>{{ item.topic_name_yin }}</em>/{{item.topic_name_en}}</div>
                </div>
              </div>
              <div class="life-content">
                <div class="title">{{item.title_en}}</div>
                <ul class="life-ul mt30" style="justify-content: space-between;">
                  <li v-for="(item1,index1) in item.detail" class="" style="border: none;margin:10px 10px;">
                    <div class="cando_movie_player Hiragana" @click="openVideoDialog(item1, index, index1)">
                      <!-- 封面图片和播放按钮 -->
                      <div class="video-cover">
                        <img :src="item1.cover_image_path" :alt="item1.title_en" class="cover-image">
                        <div class="playbutton"></div>
                      </div>
                    </div>
                    <div class="span">{{item1.title_en}}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>

      <!-- 视频弹框 -->
      <Dialog
        ref="videoDialog"
        type="alert"
        :title="currentVideo.title_en"
        width="96"
        modalClass="letModal"
        :modalFoot="false"
        @close="closeVideoDialog"
      >
        <div class="video-dialog-content" slot="mdBox">
          <div class="video-container">
<!--            <video-->
<!--              ref="dialogVideoPlayer"-->
<!--              webkit-playsinline-->
<!--              playsinline-->
<!--              controls-->
<!--              controlslist="nodownload"-->
<!--              :poster="currentVideo.cover_image_path"-->
<!--              @play="onDialogVideoPlay"-->
<!--              @pause="onDialogVideoPause"-->
<!--              @ended="onDialogVideoEnded"-->
<!--              @seeking="onDialogVideoSeeking"-->
<!--              @ratechange="onDialogVideoRateChange"-->
<!--              @loadedmetadata="onDialogVideoLoaded"-->
<!--              @error="onDialogVideoError"-->
<!--            >-->
<!--              <source :src="currentVideo.movie_path" type="video/mp4">-->
<!--              Your browser does not support the video tag.-->
<!--            </video>-->


            <video
              controls
              webkit-playsinline
              playsinline
              ref="dialogVideoPlayer"
              :poster="currentVideo.cover_image_path"
            >
              <source :src="currentVideo.movie_path" type="video/mp4">
              <p>To play the video, you need a browser that supports video tags.</p>
            </video>
          </div>
          <div class="video-controls">
            <div class="sure_btn" @click="closeVideoDialog">
              <button style="background-size: contain" class="Practice text-shadow font-family mt20">{{$t('Close')}}</button>
            </div>
          </div>
        </div>
      </Dialog>

	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        list:[],
        typeList:[],
        type:'',
        info:{},
        // 视频弹框相关数据
        currentVideo: {
          title_en: '',
          cover_image_path: '',
          movie_path: ''
        },
        isVideoPlaying: false,
        videoReportInterval: null,
        videoStartTime: 0,
        totalVideoWatchTime: 0
      }
    },
	created(){
    this.getList();
	},
    methods: {
      // 生成视频引用ID
      getVideoRef(topicIndex, itemIndex) {
        return `${topicIndex}-${itemIndex}`;
      },

      // 打开视频弹框
      openVideoDialog(videoItem, topicIndex, itemIndex) {
        this.currentVideo = {
          title_en: videoItem.title_en,
          cover_image_path: videoItem.cover_image_path,
          movie_path: videoItem.movie_path
        };

        this.$refs.videoDialog.showMaskFun();

        this.$nextTick(() => {
          setTimeout(() => {
            const video = this.$refs.dialogVideoPlayer;
            if (video) {
              video.load(); // 先 load 再 play 更稳定
              video.play().catch(err => {
                console.warn("视频播放失败：", err);
              });
            }
          }, 120);
        });
      },

      // 关闭视频弹框
      closeVideoDialog() {
        this.pauseDialogVideo();
        this.$refs.videoDialog.closeMask();
        this.isVideoPlaying = false;
        this.currentVideo = {
          title_en: '',
          cover_image_path: '',
          movie_path: ''
        };
      },

      // 播放弹框视频
      playDialogVideo() {
        const videoPlayer = this.$refs.dialogVideoPlayer;
        if (!videoPlayer) return;
        // 避免还没 play 就 pause 导致 AbortError
        setTimeout(() => {
          videoPlayer.play().catch(err => {
            console.warn("视频播放失败：", err);
          });
        }, 100);
      },

      // 暂停弹框视频
      pauseDialogVideo() {
        const videoPlayer = this.$refs.dialogVideoPlayer;
        if (videoPlayer) {
          setTimeout(() => {
            videoPlayer.pause();
          }, 50);
        }
      },

      // 重新播放视频
      replayVideo() {
        const videoPlayer = this.$refs.dialogVideoPlayer;
        if (videoPlayer) {
          videoPlayer.currentTime = 0;
          this.playDialogVideo();
        }
      },

      // 视频时间统计
      startVideoTimeReporting() {
        this.videoStartTime = Date.now();
        if (this.videoReportInterval) clearInterval(this.videoReportInterval);

        this.videoReportInterval = setInterval(() => {
          if (this.isVideoPlaying) {
            this.reportVideoWatchTime();
          }
        }, 10000);
      },

      stopVideoTimeReporting() {
        if (this.videoReportInterval) {
          clearInterval(this.videoReportInterval);
          this.videoReportInterval = null;
        }
        if (this.isVideoPlaying) {
          this.reportVideoWatchTime(true);
        }
      },

      reportVideoWatchTime(force = false) {
        return false;
        const now = Date.now();
        let currentWatch = (now - this.videoStartTime) / 1000;
        this.totalVideoWatchTime += currentWatch;
        this.videoStartTime = now;

        if (!force && currentWatch < 5) return;

        // 这里可以添加视频观看时间上报逻辑
        console.log(`视频观看时间: ${Math.round(this.totalVideoWatchTime)}秒`);

        // 示例上报代码（需要根据实际API调整）
        /*
        let data = {
          video_id: this.currentVideo.id, // 如果有视频ID的话
          seconds: Math.round(this.totalVideoWatchTime),
          video_type: 'life_culture',
          ts: Date.now()
        }
        this.$api.post('/api/video/report_time', data, r => {
          // 处理上报结果
        });
        */
      },

      // 弹框视频事件处理
      onDialogVideoPlay() {
        console.log("弹框视频开始播放");
        this.isVideoPlaying = true;
        this.startVideoTimeReporting();
      },

      onDialogVideoPause() {
        console.log("弹框视频暂停");
        this.isVideoPlaying = false;
        this.stopVideoTimeReporting();
      },

      onDialogVideoEnded() {
        console.log("弹框视频播放结束");
        this.isVideoPlaying = false;
        this.reportVideoWatchTime(true);
        this.stopVideoTimeReporting();
      },

      onDialogVideoSeeking() {
        console.log("弹框视频拖动进度条");
        this.videoStartTime = Date.now();
      },

      onDialogVideoRateChange() {
        console.log("弹框视频倍速改变");
      },

      onDialogVideoLoaded() {
        console.log("弹框视频加载完成");
      },

      onDialogVideoError(error) {
        console.error("弹框视频播放错误:", error);
      },

      // 保留原有的视频事件处理方法（用于隐藏的视频元素）
      onPlay(refName) {
        console.log(`${refName} 开始播放`);
      },

      onPause(refName) {
        console.log(`${refName} 暂停播放`);
      },

      onEnded(refName) {
        console.log(`${refName} 播放结束`);
      },

      onSeeking(refName) {
        console.log(`${refName} 拖动进度条`);
      },

      onRateChange(refName) {
        console.log(`${refName} 倍速播放`);
      },

      onVideoLoaded(refName) {
        console.log(`${refName} video loaded`);
      },

      onVideoError(refName) {
        console.error(`${refName} video error`);
      },

      playVideo(refName) {
        const videoPlayer = this.$refs[refName];
        if (videoPlayer) {
          videoPlayer.play().catch(error => {
            console.error(`Error playing ${refName} video:`, error);
          });
        }
      },

      getList(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/life_culture/list',null,r =>{
          that.$parent.returnCode(r,function(){
            that.list = r.data
            that.$parent.loadModal(false);
          })
        })
      },

      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      }
	}
}
</script>
<style scoped>
.video-dialog-content {
  width: 100%;
}

.video-container {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
}

.video-container video {
  display: block;
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  height: auto;
  max-height: 72vh;
  object-fit: contain;
  background: #000;
  border-radius: 16px;
}

.video-controls {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.cover-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.video-cover:hover .play-overlay {
  opacity: 1;
}

@media (max-width: 768px) {
  .video-container video {
    max-height: 62vh;
    border-radius: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/page/LifeCulture.vue